import React from "react"
// import "./memberCSV.css"
import * as Moment from "moment"
import styled, { css } from "styled-components"
import * as _ from "lodash"
import { ReadStream } from "fs"
import { format, parseISO } from "date-fns";


const MembersCsvWrapper = styled.div`
  display: block;
  flex-direction: column;
  padding: 0px;
  padding-right: 0px;
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-size: 0.9em;
`

const MemberLineWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${props =>
    props.pageBreak &&
    css`
      @media print {
        margin-top: 50px;
        page-break-before: always;
        break-before: always;
      }
    `}
`
const CsvHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
`

const ImageDiv = styled.div`
  img {
    width: 40px;
  }
`

const TitleWrap = styled.div`
  display: flex;
  flex-direction: row;
  vertical-align: bottom;

  h1 {
    color: #b00;
    margin: 0;
    margin-left: 10px;
    font-size: 1em;
    flex: 1 1 auto;
    align-self: flex-end;
    font-weight: 800;
  }

  h2 {
    color: #555;
    margin: 0;
    margin-left: 3px;
    font-size: 1em;
    flex: 1 1 auto;
    align-self: flex-end;
    font-weight: 800;
  }

  h3 {
    color: #888;
    margin: 0;
    margin-left: 10px;
    font-size: 0.8em;
    flex: 1 1 auto;
    align-self: flex-end;
  }
`

const MemberCsvTable = styled.table`
  background: white;
  font-size: 0.9em;

  border-spacing: 0;
  border: 1px solid #ddd;

  page-break-before: always;

  @media print {
    page-break-inside: auto;
    break-inside: auto;
  }

`

const MemberTr = styled.tr`
  td img {
    width: 16px;
  }

:nth-child(odd) {background: #eee;}
`

const MemberTd = styled.td`
  ${props =>
    props.width
      ? css`
          width: ${props.width};
        `
      : css`
          min-width: 40px;
        `};


  ${props => props.wordBreak && css`word-break: break-all;`}
  /* background: white; */
  margin: 0;

  padding: 6px;

  vertical-align: top;
  /* font-weight: bold; */
  font-size: 1em;

  border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;

  @media print {
    page-break-inside: avoid;
    break-inside: avoid;
  }
`

const Box = styled.div`
  border: 1px solid #555;
  width: 16px;
  height: 16px;
`
const TestHeaderTr = styled.tr`
  font-size: 0.9em;
  margin-top: 40px;

  td {
    padding: 6px;
    background: #333;
    color: #eee;
    font-weight: bold;
  border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
  }
`


const MembersDetailTable = props => {
  console.log("member CSV called!")
  let membersList = [...props.filteredMembers]
  let memberRanks = []

  const withLatestRank = membersList.map(member => {
    memberRanks = props.ranks.filter(rank => {
      return rank.MemberId == member.ID
    })

    const currentRank = memberRanks.length > 0 ? memberRanks[0] : null


    console.log("member: ", member)
    const activities = member.Activities ? [...member.Activities] : []
    const score = _.sumBy(activities, "Score")

    // set keiken per month
    const start_month = 9; // 9= september
    const end_month = 12 // 12= december

    let monthsScore = []
    for (var t = start_month; t <= end_month;t++) {
      const monthActivities = activities.filter(x => format(parseISO(x.Date), "M") == t ) 
      const monthScore = _.sumBy(monthActivities, "Score")
      // const value = activities.filter(x => format(parseISO(x.Date), "M")), "Score") == t }
      // console.log("item: ", monthScore)
      

      monthsScore.push({ month: t, totalScore: monthScore })
    }

    console.log("monthsScore : ", monthsScore)

    return {
      ...member,
      score: score,
      currentRank,
      monthsScore,
      currentRankImage: currentRank && currentRank.level ? "/" + currentRank.level.LevelImage : null
    }
  })

  // const sortedMembersList = _.sortBy(withLatestRank, ["currentRank.LevelId", "FirstName"])
  const sortedMembersList = _.orderBy(withLatestRank, ["Birthdate", "FirstName"], ['desc', 'asc'])

  const sprtedMemberListWithRankSeperator = sortedMembersList.reduce((all, member) => {
    member.prevRankWasDifferent =
      _.last(all) && _.last(all).currentRank && member.currentRank
        ? member.currentRank.LevelId != _.last(all).currentRank.LevelId
        : false

    return [...all, member]
  }, [])

  membersList = sprtedMemberListWithRankSeperator.map(member => {

    const memberLines = member.currentRank ? (
      <MemberTr key={member.ID} prevRankWasDifferent={member.prevRankWasDifferent}>
        <MemberTd >{member.FirstName}</MemberTd>
        <MemberTd >{member.LastName}</MemberTd>
        <MemberTd>{Moment(member.Birthdate).format("DD-MM-YYYY")}</MemberTd>
        <MemberTd>{Moment().diff(Moment(member.Birthdate), "years", false)} år</MemberTd>

        <MemberTd>
          {member.currentRank ? Moment(member.currentRank.RankDate).format("DD-MM-YYYY") : "N/A"}<br />
          {member.currentRank ? Moment(member.currentRank.RankDate).fromNow() : "N/A"}
        </MemberTd>
        <MemberTd>{member.currentRank.level.LevelTitle}</MemberTd>
        <MemberTd className="item image">
          <img className="rank" src={member.currentRankImage} />
        </MemberTd>


        <MemberTd >{member.score}</MemberTd>

        {member.monthsScore.map((sc)=> {
          return <MemberTd >{sc.totalScore}</MemberTd>
        })

        }

      </MemberTr>
    ) : (
        <tr key={member.ID}>
          <MemberTd >{member.FirstName}</MemberTd>
          <MemberTd >{member.LastName}</MemberTd>
          <MemberTd>{Moment(member.Birthdate).format("DDMMMYY")}</MemberTd>
          <MemberTd>{Moment().diff(Moment(member.Birthdate), "years", false)} år</MemberTd>


          <MemberTd />
          <MemberTd />
          <MemberTd>Begynder</MemberTd>
          <MemberTd />
          <MemberTd />

          {member.monthsScore.map((sc)=> {
          return <MemberTd >{sc.totalScore}</MemberTd>
        })

        }
        </tr>
      )

    return memberLines

  })



  return (
    <MembersCsvWrapper>

      <MemberLineWrapper id="MemberLineWrapper">

        <CsvHeader id="CsvHeader">
          <ImageDiv>
            <img src="/icons/apple-icon-114x114.png" />
          </ImageDiv>
          <TitleWrap>
            <h1>Skovbo Karate Klub</h1>
            <h2>
              {props.teamId == -1 ? "Alle" : props.teams && props.teams[props.teamId].TeamName}
            </h2>
            <h3>{Moment().format("DD. MMMM YYYY")}</h3>
          </TitleWrap>
        </CsvHeader>


        <MemberCsvTable>
          <tbody>
            <TestHeaderTr>
              <td>Fornavn</td>
              <td>Efternavn</td>
              <td>Født</td>
              <td>Alder</td>

              <td>Grad dato</td>
              <td>Grad</td>
              <td></td>

              <td>Score</td>
              <td>SEP</td>
              <td>OKT</td>
              <td>NOV</td>
              <td>DEC</td>

           

            </TestHeaderTr>
          </tbody>

          {membersList}
        </MemberCsvTable>
      </MemberLineWrapper>
    </MembersCsvWrapper>
  )
}

export default MembersDetailTable
